<template>
  <div class="single__product step__grid"
       :class="getMyTypeClass(this.my_selected_product.type)">
    <div class="step__head">
      <div class="info__block">
        <div class="info__head">
          <div class="prod">
            <div class="type__meta">
              <img :src="getMyTypeURL" alt="">
            </div>
            <p class="title-type">{{my_selected_product.type | fixType}}
            </p> 
          </div>     
          <crops-grid
            @filterthiscrop="filterCrop"
            :filCrop="filteredCropId"
            :mycrops="my_selected_product.applied_crops"
            :mygheoms="my_selected_product.gheoms">
          </crops-grid>
        </div>
        <p v-if="isEmpty" class="title">Product Grid</p>
        <p v-else class="title">{{my_selected_product.name}}</p>
      </div>
      <div class="actions__block">
        <div class="checks">
          <GheomCheckboxes
            @changegroup="onChangeGroup"
            :options="checkoptions"
            :config="checkconfig">
          </GheomCheckboxes>
        </div>
        <div class="actions__grid">
          <p class="title">Actions</p>
          <ul>
            <li :class="{active: mode == 1}">
              <a class="mode__switcher"
                v-on:click.prevent="switchmode()">
                <GripHorizontal/>
              </a>
            </li>
            <li :class="{active: mode == 0}">
              <a href="" class="mode__switcher"
                v-on:click.prevent="switchmode()">
                <FastForward/>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="step__body" 
         :class="getMode">
          <div v-if="isEmpty">
            <p>No product Selected</p>
          </div>
          <div v-else>
            <!-- FOR TIMELINE -->
            <div class="step__timeline__viz"
                  v-if="mode == '0'">
              <TimeLine
                :theproduct="productTweaked"
                :filCrop="filteredCropId"
                @showmegheom="showgheom">
              </TimeLine>
            </div>
            <!-- FOR CARDS-->
            <div v-else class="step__cards__viz">
              <gheom-card-gheom
                v-for="(gheom, index) in filGheoms" :key="gheom.id"
                :mygheom="gheom"
                :filCrop="filteredCropId"
                v-on:click.native="getgheom(index)">
              </gheom-card-gheom>
            </div>
          </div>
    </div>
  </div>
</template>

<script>
import Shared from '../Shared'
import GheomCheckboxes from './GheomCheckboxes'
import TimeLine from './TimeLine'
import {FastForward, GripHorizontal} from 'lucide-vue-next'

export default {
  extends: Shared,
  name: "",
  components: {
    GheomCheckboxes, TimeLine, GripHorizontal, FastForward
  },
  props: [
    "my_selected_product"
  ],
  computed: {
    productTweaked: function() {
      return this.my_selected_product
    },
    filGheoms: function() {
      let result = this.my_selected_product.gheoms;

      if(this.checkoptions[0].is_checked) {
        result = this.my_selected_product.gheoms.filter((gheom) => gheom.num_stages == gheom.num_stages_finished);
      }
      return result
    },

    isEmpty: function() {
      return jQuery.isEmptyObject(this.my_selected_product)
    },

    getMode: function() {
      var mymode;
      (this.mode == 0)? mymode = "mode--full-mode" : mymode = "mode--card-mode";
      if(this.checkoptions[0].is_checked) mymode = mymode + " mode--only-finished"
      return mymode;
    },

    getMyTypeURL: function() {
      var baseURL = "/images/product_types/"
      if (this.my_selected_product.type != null) {
        return baseURL+this.my_selected_product.type.name+".png";
      } else {
        return baseURL+"unk.png";
      }
      
    }
  },
  data:function(){ 
    return {
      // MODE 0 is for timeline, 1 is for cards
      mode: 1,
      checkoptions: [
        {
          "sh": "Finished Only",
          "color": "#ffffff",
          "full": "Finished Only",
          "is_all": false,
          "is_checked": false
        },
      ],
      checkconfig: {
        "orientation": "h",
        "has_all": false,
        "id": "finished_product"
      },
      selected_gheom: null,
      filteredCropId: ""
    }
  },

  methods: {
        /**
      * LOAD this.stages with the STAGES of the clicked GHEOM
      * @param index array_index of the clicked GHEOM
      */
    getgheom(index){
        let gheom = this.my_selected_product.gheoms[index];
        this.selected_gheom = gheom;
        this.$emit('ongheomselected', this.selected_gheom, index)
    },

    filterCrop(id) {
      this.filteredCropId = id;
    },

    showgheom(gh){
      this.getgheom(gh);
    },

    switchmode(){
      (this.mode == 0)? this.mode = 1 : this.mode = 0;
    },

    onChangeGroup(value, item) {
      console.log("Quitar/Poner finisheddd");
      console.log(value);
      this.checkoptions[0].is_checked = value
      //this.flagOnlyfinished = value;
    },
  }
}
</script>

